import { BREAKPOINTS, SETTINGS } from '../utils/constants';
import { throttle } from 'throttle-debounce';

const initAccordion = () => {
  const mobileOnlyAccordions = document.querySelectorAll('[data-mobile-accordion]');
  if (!mobileOnlyAccordions.length) return;

  let isDesktop = window.innerWidth >= BREAKPOINTS.DESKTOP;

  const setAccordionsOpen = (isOpen) => {
    mobileOnlyAccordions.forEach(accordion => {
      accordion.open = isOpen;
    });
  };

  setAccordionsOpen(isDesktop);

  // Mobile browsers fire resize when the address bar collapses/expands on
  // scroll, not just on an actual breakpoint change - only re-assert the
  // open/closed state on a real mobile/desktop crossing, otherwise this
  // force-closes accordions the user just opened on mobile scroll.
  const handleResize = () => {
    const isNowDesktop = window.innerWidth >= BREAKPOINTS.DESKTOP;
    if (isNowDesktop === isDesktop) return;

    isDesktop = isNowDesktop;
    setAccordionsOpen(isDesktop);
  };

  window.addEventListener('resize', throttle(SETTINGS.THROTTLE_DELAY, handleResize));
};

export default initAccordion;
